export const AUDIOS = {
  NOTIFICATION:
    "https://codeskulptor-demos.commondatastorage.googleapis.com/pang/pop.mp3",
  SOS_ALARM: "alarm.mp3",
  MESSAGE_SENT: "sent.wav",
};

export default function useAudio() {
  const audio = new Audio();

  const playAudio = (src: string, loop: boolean = false) => {
    audio.src = src;
    audio.loop = loop;
    audio.play();
  };

  const pauseAudio = () => {
    audio.pause();
  };

  const resetAudio = () => {
    audio.pause();
    audio.currentTime = 0;
    audio.play();
  };

  return {
    playAudio,
    pauseAudio,
    resetAudio,
  };
}
